import React, { useMemo, useCallback } from 'react';
import { Col, Row, Input, Select } from 'antd';
import { Param } from '../../cliDataSchema';

type Props = {
  setActiveFilterType: (status?: string) => void;
  setCurrentPage: (status: number) => void;
  setSearchText: (status: string) => void;
  activeFilterType?: string;
  featureGroups: Record<string, Record<string, Param[]>>;
  searchText: string;
};

const ProjectPresetsFilter: React.FC<Props> = ({
  setActiveFilterType,
  setCurrentPage,
  setSearchText,
  activeFilterType,
  featureGroups,
  searchText,
}) => {
  const handleTypeSelect = useCallback(
    (value: string | undefined) => {
      setActiveFilterType(value === 'All' ? undefined : value);
      setCurrentPage(1);
    },
    [setActiveFilterType, setCurrentPage],
  );

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(e.target.value);
      setCurrentPage(1);
    },
    [setSearchText, setCurrentPage],
  );

  const filterParamGroup = useCallback(
    (featureGroups: Record<string, Record<string, Param[]>>): string[] => {
      const result: string[] = [];

      Object.values(featureGroups).forEach((paramGroups) => {
        Object.keys(paramGroups).forEach((paramGroup) => {
          if (
            paramGroups[paramGroup].length > 0 &&
            !result.includes(paramGroup)
          ) {
            result.push(paramGroup);
          }
        });
      });

      return result;
    },
    [],
  );

  const paramGroups = useMemo(
    () => filterParamGroup(featureGroups),
    [featureGroups, filterParamGroup],
  );

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
      <Col xs={24} sm={12} lg={6}>
        <Select
          value={activeFilterType || 'All'}
          onChange={handleTypeSelect}
          style={{ width: '100%' }}
        >
          <Select.Option value="All">All types</Select.Option>
          {paramGroups.map((group, index) => (
            <Select.Option key={index} value={group}>
              {group}
            </Select.Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} lg={18}>
        <Input
          placeholder={`Search name and or value`}
          value={searchText}
          onChange={handleSearchChange}
          style={{ width: '100%' }}
        />
      </Col>
    </Row>
  );
};

export default ProjectPresetsFilter;
